import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay } from 'swiper/modules';

import meatBanner from '../../assets/meatBanner.svg';
import fruitsBanner from '../../assets/fruitsBanner.svg';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BannerSlider = ({ merchants = [] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const sponsoredMerchants = merchants.filter(
    (m) => m.sponsored && m.sponsoredImage && m.sponsoredImage.trim() !== '',
  );

  const handlePromoBannerClick = (banner) => {
    navigate('/search', { state: { searchTerm: banner.searchTerm } });
  };

  const handleMerchantBannerClick = (merchant) => {
    navigate(`/merchant-details/${merchant._id}`);
  };

  const banners = [
    ...sponsoredMerchants.map((m) => ({
      type: 'merchant',
      src: m.sponsoredImage,
      merchant: m,
    })),
    ...[
      { type: 'promo', src: meatBanner, searchTerm: t('meat') },
      { type: 'promo', src: fruitsBanner, searchTerm: t('fruit') },
    ],
  ];

  return (
    <section className="px-2 md:px-4 lg:px-6">
      <div className="relative rounded-xl overflow-hidden">
        <Swiper
          spaceBetween={10}
          rewind={true}
          autoplay={{
            delay: 2300,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={375}
          breakpoints={{
            10: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >
          {banners.map((banner, index) => {
            const onActivate = () =>
              banner.type === 'promo'
                ? handlePromoBannerClick(banner)
                : handleMerchantBannerClick(banner.merchant);
            return (
              <SwiperSlide key={index}>
                <button
                  type="button"
                  onClick={onActivate}
                  className="block w-full rounded-xl overflow-hidden cursor-pointer text-left"
                  aria-label={`Banner ${index + 1}`}
                >
                  <div className="w-full aspect-[16/9] sm:aspect-[5/3] lg:aspect-[3/2] rounded-xl overflow-hidden">
                    <img
                      src={banner.src}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default BannerSlider;
